module.exports = __webpack_public_path__ + "img/hungary.567411ad.svg";